import {
  ExecutorType,
  UpdateExecutorType
} from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { Executor, Executors } from 'service/dto/executor.dto';
import { errorHandler } from 'utils';

class ExecutorService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createExecutor = async (executorType: ExecutorType) => {
    try {
      const response = await this.baseService.post(
        '/executor/create',
        executorType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  checkIfEmailInUse = async (email: string) => {
    const response = await this.baseService.get(
      `/executor/email-exists/${email}`
    );
    return response.data;
  };

  updateExecutor = async (executorId: number, update: UpdateExecutorType) => {
    try {
      const response = await this.baseService.put(
        `/executor/${executorId}`,
        update
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getExecutor = async (executorId: number): Promise<Executor> => {
    try {
      const response = await this.baseService.get(`/executor/${executorId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getExecutors = async (search?: string | undefined): Promise<Executors> => {
    try {
      const response = await this.baseService.get(`/executor?search=${search}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteExecutor = async (executorId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/executor/${executorId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default ExecutorService;
